<template>
    <a-layout style="min-height: 100vh;">
        <UserHead />
        <a-layout>
            <a-layout-header style="padding: 0; background: #fff; border-bottom: 1px solid #f0f0f0;">
                <HeadTop />
            </a-layout-header>
            <a-layout-content class="page-content" style="padding: 24px; background: #f5f7fa;">
                <div class="page-inner">
                    <!-- 顶部统计卡片 -->
                    <a-row :gutter="[16, 16]" class="stat-row">
                        <a-col :xs="24" :sm="12" :md="6">
                            <a-card class="stat-card" :bordered="false">
                                <div class="stat-inner">
                                    <div class="stat-icon stat-icon-blue">
                                        <BankOutlined />
                                    </div>
                                    <div class="stat-info">
                                        <div class="stat-label">总提现记录</div>
                                        <div class="stat-value">{{ Withdrawal_Conf.total }}</div>
                                    </div>
                                </div>
                            </a-card>
                        </a-col>
                        <a-col :xs="24" :sm="12" :md="6">
                            <a-card class="stat-card" :bordered="false">
                                <div class="stat-inner">
                                    <div class="stat-icon stat-icon-orange">
                                        <ClockCircleOutlined />
                                    </div>
                                    <div class="stat-info">
                                        <div class="stat-label">处理中</div>
                                        <div class="stat-value stat-value-sm">{{ pendingCount }}</div>
                                    </div>
                                </div>
                            </a-card>
                        </a-col>
                        <a-col :xs="24" :sm="12" :md="6">
                            <a-card class="stat-card" :bordered="false">
                                <div class="stat-inner">
                                    <div class="stat-icon stat-icon-green">
                                        <CheckCircleOutlined />
                                    </div>
                                    <div class="stat-info">
                                        <div class="stat-label">已打款</div>
                                        <div class="stat-value stat-value-sm">{{ successCount }}</div>
                                    </div>
                                </div>
                            </a-card>
                        </a-col>
                        <a-col :xs="24" :sm="12" :md="6">
                            <a-card class="stat-card" :bordered="false">
                                <div class="stat-inner">
                                    <div class="stat-icon stat-icon-purple">
                                        <CloseCircleOutlined />
                                    </div>
                                    <div class="stat-info">
                                        <div class="stat-label">已驳回</div>
                                        <div class="stat-value stat-value-sm">{{ rejectedCount }}</div>
                                    </div>
                                </div>
                            </a-card>
                        </a-col>
                    </a-row>

                    <!-- 提现列表 -->
                    <a-card :bordered="false" class="table-card">
                        <template #title>
                            <div class="card-title-row">
                                <span class="card-title-text">我的提现记录</span>
                                <a-tag color="blue">{{ Withdrawal_Conf.total }} 条</a-tag>
                            </div>
                        </template>
                        <template #extra>
                            <a-button type="primary" @click="applyWithdrawal('dialog')">
                                <template #icon>
                                    <PlusOutlined />
                                </template>申请提现
                            </a-button>
                        </template>

                        <!-- PC 端表格 -->
                        <a-table class="withdrawal-table-pc" :data-source="Withdrawal_data" :pagination="false"
                            row-key="id" :scroll="{ x: 1100 }" size="small" :loading="tableLoading" bordered
                            :columns="withdrawalColumns">
                            <template #bodyCell="{ column, record }">
                                <!-- 提现金额 -->
                                <template v-if="column.key === 'money'">
                                    <span :class="['money-text', record.state == 1 ? 'money-success' : '']">
                                        {{ record.money }} 元
                                    </span>
                                </template>

                                <!-- 收款码 -->
                                <template v-else-if="column.key === 'skm'">
                                    <a-image :src="record.skm" width="60" height="60" style="border-radius: 6px;" />
                                </template>

                                <!-- 提现方式 -->
                                <template v-else-if="column.key === 'act'">
                                    <span v-if="record.act === 'wx'" class="act-cell">
                                        <WechatOutlined style="color: #07c160;" /> 微信
                                    </span>
                                    <span v-else-if="record.act === 'zfb'" class="act-cell">
                                        <AlipayCircleOutlined style="color: #1677ff;" /> 支付宝
                                    </span>
                                    <span v-else>{{ record.act || '未知' }}</span>
                                </template>

                                <!-- 状态 -->
                                <template v-else-if="column.key === 'state'">
                                    <a-tag v-if="record.state == 0" color="gold">
                                        <ClockCircleOutlined /> 等待审核
                                    </a-tag>
                                    <a-tag v-else-if="record.state == 1" color="green">
                                        <CheckCircleOutlined /> 已打款
                                    </a-tag>
                                    <a-tag v-else-if="record.state == -1" color="red">
                                        <CloseCircleOutlined /> 已驳回
                                    </a-tag>
                                    <a-tag v-else color="default">未知</a-tag>
                                </template>

                                <!-- 处理结果 -->
                                <template v-else-if="column.key === 'res_code'">
                                    <span v-if="!isNull(record.res_code)">{{ record.res_code }}</span>
                                    <span v-else class="text-muted">无</span>
                                </template>

                                <!-- 处理时间 -->
                                <template v-else-if="column.key === 'end_time'">
                                    <span v-if="!isNull(record.end_time)">{{ record.end_time }}</span>
                                    <span v-else class="text-muted">无</span>
                                </template>
                            </template>
                        </a-table>

                        <!-- 手机端卡片列表 -->
                        <div class="withdrawal-card-list" v-if="Withdrawal_data && Withdrawal_data.length > 0">
                            <a-card v-for="record in Withdrawal_data" :key="record.id" class="withdrawal-mobile-card"
                                :bordered="false">
                                <div class="mobile-card-head">
                                    <div class="mobile-card-title">
                                        <span class="withdrawal-id">#{{ record.id }}</span>
                                        <a-tag v-if="record.state == 0" color="gold">等待审核</a-tag>
                                        <a-tag v-else-if="record.state == 1" color="green">已打款</a-tag>
                                        <a-tag v-else-if="record.state == -1" color="red">已驳回</a-tag>
                                        <a-tag v-else color="default">未知</a-tag>
                                    </div>
                                    <span class="money-text" :class="record.state == 1 ? 'money-success' : ''">
                                        {{ record.money }} 元
                                    </span>
                                </div>
                                <div class="mobile-card-body">
                                    <div class="mobile-field">
                                        <span class="mobile-label">收款方式</span>
                                        <span class="mobile-value">
                                            <WechatOutlined v-if="record.act === 'wx'" style="color: #07c160;" />
                                            <AlipayCircleOutlined v-else-if="record.act === 'zfb'"
                                                style="color: #1677ff;" />
                                            {{ record.act === 'wx' ? '微信' : record.act === 'zfb' ? '支付宝' : '未知' }}
                                        </span>
                                    </div>
                                    <div class="mobile-field" v-if="record.skm">
                                        <span class="mobile-label">收款码</span>
                                        <a-image :src="record.skm" width="64" height="64" style="border-radius: 6px;" />
                                    </div>
                                    <div class="mobile-field">
                                        <span class="mobile-label">备注</span>
                                        <span class="mobile-value">{{ record.remarks || '无' }}</span>
                                    </div>
                                    <div class="mobile-field">
                                        <span class="mobile-label">处理结果</span>
                                        <span class="mobile-value">{{ record.res_code || '无' }}</span>
                                    </div>
                                    <div class="mobile-field">
                                        <span class="mobile-label">申请时间</span>
                                        <span class="mobile-value">{{ record.add_time }}</span>
                                    </div>
                                    <div class="mobile-field">
                                        <span class="mobile-label">处理时间</span>
                                        <span class="mobile-value">{{ record.end_time || '无' }}</span>
                                    </div>
                                </div>
                            </a-card>
                        </div>

                        <!-- 空状态 -->
                        <a-empty v-if="(!Withdrawal_data || Withdrawal_data.length === 0) && !tableLoading"
                            description="暂无提现记录" />

                        <!-- 分页 -->
                        <div class="table-pagination">
                            <a-pagination v-model:current="Withdrawal_Conf.currentPage"
                                v-model:page-size="Withdrawal_Conf.pageSize" :page-size-options="[10, 25, 50]"
                                :disabled="tableLoading" show-size-changer show-quick-jumper
                                :show-total="(total) => `共 ${total} 条记录`" :total="Withdrawal_Conf.total"
                                @change="WithdrawalPageChange" />
                        </div>
                    </a-card>
                </div>
            </a-layout-content>
        </a-layout>
    </a-layout>

    <!-- 申请提现对话框 -->
    <a-modal v-model:open="Withdrawal_Dialog.Visible" title="申请提现" :width="540" :mask-closable="false" :footer="null"
        centered>
        <a-form :model="Withdrawal_Dialog.from" layout="vertical">
            <a-form-item label="提现金额">
                <a-input-number :max="Withdrawal_Dialog.maxMoney" v-model:value="Withdrawal_Dialog.from.money"
                    style="width: 100%;" :placeholder="'单笔提现范围:' + 0 + '--' + Withdrawal_Dialog.maxMoney" />
            </a-form-item>
            <a-form-item label="选择收款方式">
                <a-select v-model:value="Withdrawal_Dialog.from.selectAct" placeholder="--请选择--">
                    <a-select-option v-for="(item, i) in Withdrawal_Dialog.from.skAct" :key="i" :value="item.act">{{
                        item.str }}</a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item label="备注">
                <a-input type="textarea" :rows="4" v-model:value="Withdrawal_Dialog.from.remarks"
                    placeholder="请输入备注信息（选填）" />
            </a-form-item>
        </a-form>
        <div class="dialog-footer" style="margin-top: 16px;">
            <a-button @click="Withdrawal_Dialog.Visible = false">关闭</a-button>
            <a-button type="primary" @click="applyWithdrawal('apply')">申请提现</a-button>
        </div>
    </a-modal>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue';
import UserHead from '@/components/UserHead.vue';
import HeadTop from '@/components/UserHeadTop.vue';
import { isNull } from '@/utils/publicMethods';
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils';
import { message } from 'ant-design-vue';
import axios from 'axios';
import {
    BankOutlined,
    ClockCircleOutlined,
    CheckCircleOutlined,
    CloseCircleOutlined,
    PlusOutlined,
    WechatOutlined,
    AlipayCircleOutlined,
} from '@ant-design/icons-vue';

const baseURL = process.env.VUE_APP_API_BASE_URL;

// ============ 状态 ============
const Withdrawal_Conf = ref({
    currentPage: 1,
    pageSize: 10,
    total: 0,
});

const Withdrawal_data = ref<any[]>([]);

const tableLoading = ref(false);

const Withdrawal_Dialog = ref({
    Visible: false,
    from: {
        money: '' as any,
        skAct: [
            { act: 'wx', skm: '', str: '微信' },
            { act: 'zfb', skm: '', str: '支付宝' },
        ] as Array<{ act: string; skm: string; str: string }>,
        selectAct: '',
        remarks: '',
    },
    maxMoney: 0,
});

// ============ 统计计算 ============
const pendingCount = computed(() => {
    return Withdrawal_data.value.filter((r: any) => r.state == 0).length;
});
const successCount = computed(() => {
    return Withdrawal_data.value.filter((r: any) => r.state == 1).length;
});
const rejectedCount = computed(() => {
    return Withdrawal_data.value.filter((r: any) => r.state == -1).length;
});

// ============ 列配置 ============
const withdrawalColumns = [
    { title: 'ID', dataIndex: 'id', key: 'id', width: 70, align: 'center' as const },
    { title: '提现金额', key: 'money', width: 120, align: 'right' as const },
    { title: '收款码', key: 'skm', width: 90, align: 'center' as const },
    { title: '提现方式', key: 'act', width: 100, align: 'center' as const },
    { title: '备注', dataIndex: 'remarks', key: 'remarks', ellipsis: true },
    { title: '状态', key: 'state', width: 100, align: 'center' as const },
    { title: '处理结果', dataIndex: 'res_code', key: 'res_code', width: 130 },
    { title: '申请时间', dataIndex: 'add_time', key: 'add_time', width: 160 },
    { title: '处理时间', key: 'end_time', width: 160 },
];

// ============ 业务方法 ============
const getWithdrawalAct = (act: number) => {
    switch (act) {
        case -1:
            return '提现驳回';
        case 0:
            return '等待审核';
        case 1:
            return '已打款';
        default:
            return '未知';
    }
};

const getUserWithdrawal = () => {
    tableLoading.value = true;
    openLoading();
    const data = new FormData();
    data.append('page', Withdrawal_Conf.value.currentPage);
    data.append('pageSize', Withdrawal_Conf.value.pageSize);
    const headers = {
        token: localStorage.getItem('token'),
    };

    axios
        .post(baseURL + '/userApi/getUserWithdrawal', data, { timeout: 5000, headers })
        .then((res) => {
            if (res.data.code == 200) {
                Withdrawal_data.value = res.data.data;
                Withdrawal_Conf.value.total = res.data.total;
            } else {
                message.error(res.data.msg);
            }

            if (res.data.code == 401) {
                message.error(res.data.msg);
                setTimeout(() => {
                    location.href = '/Login';
                }, 1000);
            }
        })
        .catch((err) => {
            message.error(err);
        })
        .finally(() => {
            tableLoading.value = false;
            fullscreenLoading.close();
        });
};

const getSkm = () => {
    openLoading();
    const headers = {
        token: localStorage.getItem('token'),
    };

    axios
        .post(baseURL + '/userApi/getSkm', new FormData(), { timeout: 5000, headers })
        .then((res) => {
            fullscreenLoading.close();
            if (res.data.code == 200) {
                Withdrawal_Dialog.value.from.skAct = res.data.data;
                Withdrawal_Dialog.value.maxMoney = res.data.money;
            } else if (res.data.code == 401) {
                message.error(res.data.msg);
                setTimeout(() => {
                    location.href = '/Login';
                }, 1000);
            }
        })
        .catch((err) => {
            fullscreenLoading.close();
            message.error(err);
        });
};

const WithdrawalPageChange = (page: number, pageSize: number) => {
    Withdrawal_Conf.value.currentPage = page;
    Withdrawal_Conf.value.pageSize = pageSize;
    getUserWithdrawal();
};

const applyWithdrawal = (act: string) => {
    if (act == 'dialog') {
        Withdrawal_Dialog.value.Visible = true;
        getSkm();
    } else if (act == 'apply') {
        const data = new FormData();

        if (isNull(Withdrawal_Dialog.value.from.money)) {
            message.error('请输入提现金额');
            return;
        }
        data.append('money', Withdrawal_Dialog.value.from.money);

        data.append('act', Withdrawal_Dialog.value.from.selectAct);
        const temp = Withdrawal_Dialog.value.from.skAct.filter(
            (item: any) => item.act == Withdrawal_Dialog.value.from.selectAct
        );
        if (temp.length == 0) {
            message.error('请选择收款信息');
            return;
        }

        data.append('skm', temp[0].skm);
        data.append('remarks', Withdrawal_Dialog.value.from.remarks);
        const headers = {
            token: localStorage.getItem('token'),
        };

        openLoading();
        axios
            .post(baseURL + '/userApi/applyWithdrawal', data, { timeout: 5000, headers })
            .then((res) => {
                fullscreenLoading.close();
                if (res.data.code == 401) {
                    message.error(res.data.msg);
                    setTimeout(() => {
                        location.href = '/login';
                    }, 1000);
                } else if (res.data.code == 200) {
                    message.success(res.data.msg);
                    Withdrawal_Dialog.value.Visible = false;
                    getUserWithdrawal();
                } else {
                    message.error(res.data.msg);
                }
            })
            .catch((err) => {
                fullscreenLoading.close();
                message.error(err);
            });
    }
};

// ============ 生命周期 ============
onMounted(() => {
    getUserWithdrawal();
});
</script>

<style lang="scss">
/* ===== Page Container ===== */
.page-inner {
    max-width: 1200px;
    margin: 0 auto;
}

/* ===== Modal Width Override ===== */
:deep(.ant-modal) {
    max-width: none !important;
}

/* ===== Stat Cards ===== */
.stat-row {
    margin-bottom: 12px;
}

.stat-card {
    border-radius: 8px;
    transition: all 0.3s ease;

    &:hover {
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
        transform: translateY(-2px);
    }

    :deep(.ant-card-body) {
        padding: 16px 20px;
    }
}

.stat-inner {
    display: flex;
    align-items: center;
    gap: 14px;
}

.stat-icon {
    width: 44px;
    height: 44px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    flex-shrink: 0;

    &.stat-icon-blue {
        background: linear-gradient(135deg, #e6f4ff, #bae0ff);
        color: #1677ff;
    }

    &.stat-icon-green {
        background: linear-gradient(135deg, #f6ffed, #d9f7be);
        color: #52c41a;
    }

    &.stat-icon-orange {
        background: linear-gradient(135deg, #fff7e6, #ffd591);
        color: #fa8c16;
    }

    &.stat-icon-purple {
        background: linear-gradient(135deg, #f9f0ff, #d3adf7);
        color: #722ed1;
    }
}

.stat-info {
    flex: 1;
    min-width: 0;
}

.stat-label {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.45);
    margin-bottom: 2px;
}

.stat-value {
    font-size: 22px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.88);
    line-height: 1.2;

    &.stat-value-sm {
        font-size: 18px;
    }
}

/* ===== Table Card ===== */
.table-card {
    border-radius: 8px;

    :deep(.ant-card-head) {
        border-bottom: 1px solid #f0f0f0;
        padding: 0 16px;
        min-height: 48px;
    }

    :deep(.ant-card-body) {
        padding: 0 16px 16px;
    }
}

.card-title-row {
    display: flex;
    align-items: center;
    gap: 10px;
}

.card-title-text {
    font-weight: 600;
    font-size: 14px;
}

/* ===== Money Text ===== */
.money-text {
    font-weight: 600;
    font-size: 14px;
    color: #ff4d4f;
}

.money-success {
    color: #52c41a;
}

.text-muted {
    color: rgba(0, 0, 0, 0.25);
    font-size: 12px;
}

.act-cell {
    display: inline-flex;
    align-items: center;
    gap: 4px;
}

/* ===== Table Density ===== */
.table-card :deep(.ant-table) {
    .ant-table-thead>tr>th {
        padding: 8px 10px !important;
        font-size: 12px;
        background: #fafafa;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.65);
        white-space: nowrap;
    }

    .ant-table-tbody>tr>td {
        padding: 6px 10px !important;
        font-size: 13px;
    }

    .ant-table-cell {
        padding: 6px 10px !important;
    }
}

/* ===== Pagination ===== */
.table-pagination {
    display: flex;
    justify-content: flex-end;
    padding-top: 12px;
}

/* ===== Mobile Card List (hidden on PC) ===== */
.withdrawal-card-list {
    display: none;
    gap: 12px;

    .withdrawal-mobile-card {
        border-radius: 10px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);

        :deep(.ant-card-body) {
            padding: 12px 14px;
        }
    }

    .mobile-card-head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        padding-bottom: 8px;
        border-bottom: 1px solid #f0f0f0;
        flex-wrap: wrap;
        gap: 6px;
    }

    .mobile-card-title {
        display: flex;
        align-items: center;
        gap: 8px;
        font-weight: 600;
        font-size: 14px;
        flex: 1;
    }

    .withdrawal-id {
        color: rgba(0, 0, 0, 0.65);
        font-size: 13px;
    }

    .mobile-card-body {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .mobile-field {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 13px;
    }

    .mobile-label {
        color: rgba(0, 0, 0, 0.45);
        min-width: 72px;
        flex-shrink: 0;
        font-size: 12px;
    }

    .mobile-value {
        color: rgba(0, 0, 0, 0.88);
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}

/* ===== Dialog Footer ===== */
.dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
}

/* ===== Mobile Responsive ===== */
@media screen and (max-width: 768px) {

    /* Layout */
    .ant-layout-content {
        padding: 12px !important;
    }

    /* PC vs Mobile Toggle */
    .withdrawal-table-pc,
    .table-pagination {
        display: none !important;
    }

    .withdrawal-card-list {
        display: flex !important;
        flex-direction: column;
    }

    /* Stat Cards */
    .stat-row {
        margin-bottom: 8px;
    }

    .stat-card :deep(.ant-card-body) {
        padding: 12px 14px;
    }

    .stat-inner {
        gap: 10px;
    }

    .stat-icon {
        width: 36px;
        height: 36px;
        font-size: 16px;
        border-radius: 8px;
    }

    .stat-label {
        font-size: 11px;
    }

    .stat-value {
        font-size: 18px;

        &.stat-value-sm {
            font-size: 15px;
        }
    }

    /* Table Card */
    .table-card :deep(.ant-card-head) {
        padding: 0 12px;
        min-height: 44px;
    }

    .table-card :deep(.ant-card-body) {
        padding: 0 12px 12px;
    }

    .card-title-row {
        gap: 8px;
        flex-wrap: wrap;
    }

    .card-title-text {
        font-size: 13px;
    }
}

/* Very small phones */
@media screen and (max-width: 480px) {
    .ant-layout-content {
        padding: 8px !important;
    }

    .stat-card :deep(.ant-card-body) {
        padding: 10px 12px;
    }

    .stat-icon {
        width: 32px;
        height: 32px;
        font-size: 14px;
    }

    .stat-value {
        font-size: 16px;

        &.stat-value-sm {
            font-size: 14px;
        }
    }
}
</style>
